import { shippingGiftCalculatorInit } from '../../cartDrawerFreeShippingCalculator/scripts';

$(window).on('load', function () {
  const $wrapper = $('.announcement-bar__wrapper');
  const initialWraperHeight = parseInt($('.announcement-bar__wrapper').css('height'));

  if ($wrapper.length == 0) return;

  function mainCarouselFunc() {
    // Get the first announcement bar with custom color
    const announcementBarFirst = document.querySelector('.announcement-bar__wrapper .announcement-bar[custom-color]');
    if (announcementBarFirst) {
      const bgColor = announcementBarFirst.dataset.color || '';
      const textColor = announcementBarFirst.dataset.textColor || '';
      
      // Apply styles
      announcementBarFirst.style.backgroundColor = bgColor;
      
      // Update text elements
      const textElements = announcementBarFirst.querySelectorAll('.announcement-bar__text, .announcement-bar__arrow');
      textElements.forEach(el => {
        el.style.color = textColor;
      });
    }

    // Get all visible announcement bars
    const allBars = Array.from(document.querySelectorAll('.announcement-bar__wrapper .announcement-bar:not(.hidden)'));
    const messagesCount = allBars.length;
    
    // Get carousel settings from the wrapper
    const wrapper = document.querySelector('.announcement-bar__wrapper');
    if (!wrapper) return;
    
    const interval = (parseInt(wrapper.dataset.interval) || 5) * 1000; // Default to 5 seconds if not set
    const transition = wrapper.dataset.transitionSpeed || 'standard';
    const isCarousel = wrapper.dataset.isCarousel === 'true';

    // Set transition speed based on setting
    let transitionSpeed;
    switch (transition) {
      case 'swift':
        transitionSpeed = 400;
        break;
      case 'standard':
        transitionSpeed = 600;
        break;
      case 'slow':
        transitionSpeed = 1000;
        break;
      default:
        transitionSpeed = 600; // Default to standard if not specified
    }

    // Set initial active class
    const firstBar = allBars[0];
    if (firstBar) firstBar.classList.add('active');
    
    // Set up the carousel interval if needed
    if (messagesCount > 1 && isCarousel) {
      setInterval(() => carousel(transitionSpeed), interval);
    }

    function carousel(transitionSpeed) {
    const wrapper = document.querySelector('.announcement-bar__wrapper');
    if (!wrapper) return;
    
    // Set the transition speed in CSS custom property
    document.documentElement.style.setProperty('--transition-speed', `${transitionSpeed}ms`);
    
    const active = wrapper.querySelector('.announcement-bar.active');
    if (!active) return;
    
    const allBars = Array.from(wrapper.querySelectorAll('.announcement-bar'));
    if (allBars.length < 2) return;
    
    const next = active.nextElementSibling && active.nextElementSibling.classList.contains('announcement-bar')
      ? active.nextElementSibling
      : wrapper.querySelector('.announcement-bar');
    
    // Set dynamic colors if needed
    if (next.hasAttribute('custom-color')) {
      next.style.setProperty('--announcement-bg-color', next.dataset.color || 'transparent');
      const textElement = next.querySelector('.announcement-bar__text');
      if (textElement) {
        textElement.style.color = next.dataset.textColor || '';
      }
    }
    
    // Set initial z-index for proper stacking 
    next.style.zIndex = '2';
    
    // Remove active class from current and add to next
    active.classList.remove('active'); 
    next.classList.add('active');
    
    // After transition completes, cleanup z-index
    const onTransitionEnd = () => {
      next.style.zIndex = '';
      next.removeEventListener('transitionend', onTransitionEnd);
      
      // Reset the transition speed to default after animation
      document.documentElement.style.removeProperty('--transition-speed');
    };
    
    // Add transition end listener
    next.addEventListener('transitionend', onTransitionEnd, { once: true });
    
    // Fallback in case transitionend doesn't fire
    const fallbackTimeout = setTimeout(() => {
      next.style.zIndex = '';
      next.removeEventListener('transitionend', onTransitionEnd);
      document.documentElement.style.removeProperty('--transition-speed');
    }, transitionSpeed + 50);
    
    // Clean up the timeout when transition ends
    next.addEventListener('transitionend', () => clearTimeout(fallbackTimeout), { once: true });
    } 
  }

  function mainCountdown() {
    const shopName = $($wrapper).data('shop-name');
    let timezone;
    switch (shopName) {
      case 'Organic Basics EU':
        timezone = 'Europe/Copenhagen';
        break;
      case 'Organic Basics US':
        timezone = 'America/New_York';
        break;
      case 'Organic Basics UK':
        timezone = 'Europe/London';
        break;
      default:
        timezone = 'Europe/Copenhagen';
        break;
    }

    const now = new Date();
    const currentDate = new Date(new Date().toLocaleString('en-US', { timezone: timezone }));
    const currentTime = now.getTime();

    const $wrapperCountdown = $('.announcement-countdown');

    $($wrapperCountdown).each(function () {
      const $currEl = $(this);
      const $currWrapper = $($currEl).closest('.announcement-bar__wrapper');
      const $currItem = $($currEl).closest('.announcement-bar');
      itemCountdown($currEl, $currWrapper, $currItem);
    });

    function itemCountdown($currEl, $currWrapper, $currItem) {
      // Set due date
      const dueDateVal = $($currEl).data('due-date');
      let dueDateArr = dueDateVal.split(',');

      // Remove all empty spaces
      dueDateArr = dueDateArr.map((s) => s.trim());
      // Change strings to number
      dueDateArr = dueDateArr.map((str) => Number(str));
      dueDateArr[1] = dueDateArr[1] - 1;

      const dueDate = new Date(new Date(dueDateArr[0], dueDateArr[1], dueDateArr[2], dueDateArr[3], dueDateArr[4]).toLocaleString('en-US', { timezone: timezone }));
      const dueEventTime = dueDate.getTime();
      const remTime = dueEventTime - currentTime;

      // Set from date

      const fromDateVal = $($currEl).data('from-date');
      let fromDateArr = fromDateVal.split(',');

      // Remove all empty spaces
      fromDateArr = fromDateArr.map((s) => s.trim());
      // Change strings to number
      fromDateArr = fromDateArr.map((str) => Number(str));
      fromDateArr[1] = fromDateArr[1] - 1;
      const fromDate = new Date(new Date(fromDateArr[0], fromDateArr[1], fromDateArr[2], fromDateArr[3], fromDateArr[4]).toLocaleString('en-US', { timezone: timezone }));
      const fromEventTime = fromDate.getTime();

      if (fromEventTime > currentTime) {
        $currItem.remove();
      }

      if (dueEventTime < currentTime) {
        $currItem.remove();
      }

      let sec = Math.floor(remTime / 1000);
      let min = Math.floor(sec / 60);
      let hour = Math.floor(min / 60);
      let day = Math.floor(hour / 24);

      hour %= 24;
      min %= 60;
      sec %= 60;

      (function renderTime() {
        $($currEl).find('.days').text(day);
        $($currEl).find('.hours').text(hour);
        $($currEl).find('.minutes').text(min);
        $($currEl).find('.seconds').text(sec);
      })();
    }

    setTimeout(mainCountdown, 1000);
  }

  function notShownOnThisPage() {
    $wrapper.find('.not-shown-on-this-page').remove();
    if ($wrapper.children().length == 0) $wrapper.remove();
  }

  notShownOnThisPage();
  mainCountdown();
  mainCarouselFunc();
  // Second call serves as a callback function once carousel changed DOM
  notShownOnThisPage();

  if (document.querySelector('[shipping-modal-enabled]')) {
    let countryMinFreeShipping = sessionStorage.getItem('CountryMinFreeShipping');

    function replaceVariables(textToReplace, newText) {
      let announcementElement = document.querySelector('[shipping-modal-enabled] .announcement-bar__text');
      let announcementText = announcementElement.textContent;
      announcementElement.textContent = announcementText.replace(textToReplace, newText);
    }

    function checkFreeShippingAmount(t, e) {
      if (countryMinFreeShipping) {
        countryMinFreeShipping = Number(countryMinFreeShipping).toFixed(2);
        replaceVariables('[VALUE]', countryMinFreeShipping);
        shippingGiftCalculatorInit();
      } else {
        if (t) {
          e[0].classList.add('country-search-result');
          let amount = document.querySelector('.country-search-result .free.min-amount').innerHTML.split(' ');
          sessionStorage.setItem('CountryMinFreeShipping', amount[0]);
          let final = Number(amount[0]).toFixed(2);
          replaceVariables('[VALUE]', final);
          shippingGiftCalculatorInit();
        }
      }
    }

    async function fetchLocationInformation() {
      const access_key = document.querySelector('[data-ipstack-access-key]').getAttribute('data-ipstack-access-key');
      if (!access_key) {
				console.error('IPStack key is missing');
				return;
			}
      let response = await fetch('https://api.ipstack.com/check?access_key=' + access_key);
      let data = await response.json();
      document.getElementById('shipping-search').value = data.country_name;
      sessionStorage.setItem('IPStackVisitorCountry', data.country_name);
      $('#shipping-search').trigger('keyup');
      replaceVariables('[COUNTRY]', data.country_name);
    }

    async function fetchShippingRates() {
      let data;
      let shippingRates = sessionStorage.getItem('StoreShippingRates');

      if (shippingRates) {
        data = JSON.parse(shippingRates);
      } else {
        let store = Shopify.shop;
        let response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getShippingZones?store=${store}`);
        data = await response.json();
        sessionStorage.setItem('StoreShippingRates', JSON.stringify(data));
      }

      populateTable(data);
      inputCountryCheck();
    }

    let working_days = shippingTranslationKeys['shipping_modal.shipping_table.working_days'];

    let currency = {
      EUR: '€',
      USD: '$',
      GBP: '£',
      DKK: 'DKK',
    };

    function populateTable(data) {
      let countryListLength = document.querySelectorAll('tbody.country.tbody-country').length;

      if (countryListLength < 2) {
        data.forEach((e) => {
          let o = $('.tbody-country:last');
          o.clone().appendTo('.shipping-prices-table'),
            e.forEach(function (e, t) {
              var n = o.find('.shipping-row:last');
              n.clone().appendTo(o), n.append('<th class="shipping col--shipping" scope="row">'.concat(e.shipping_name, '</th>')), n.append('<td class="delivery col--delivery">'.concat(e.days.split(' ')[0], ' ').concat(working_days, '</td>')), n.append('<td class="price">'.concat(e.price, ' ').concat(currency[Shopify.currency.active], '</td>')), 'N/A' === e.free_above ? n.append('<td class="free">'.concat(e.free_above, '</td>')) : n.append('<td class="free min-amount">'.concat(e.free_above, ' ').concat(currency[Shopify.currency.active], '</td>'));
            }),
            o.find('.shipping-row').eq(0).find('.col--country').text(e[0].country),
            o.find('.shipping-row').not(':eq(0)').find('.col--country').remove();
        });
      }
    }

    function inputCountryCheck() {
      $('.shipping-info-container__table').each(function (e) {
        var t = $(this);
        t.find('#shipping-search').on('keyup loaded change ready focus', function () {
          if ($(this).val().length > 2) {
            var n = $(this).val().toLowerCase(),
              o = 0;
            t.find('tbody.country').filter(function () {
              var e = $(this),
                t = -1 < e.text().toLowerCase().indexOf(n);
              e.toggle(t), (o += t ? 1 : 0);
              checkFreeShippingAmount(t, e);
            }),
              0 === o &&
                t.find('tbody.country').filter(function () {
                  var e = $(this),
                    t = -1 < e.text().toLowerCase().indexOf('rest of world');
                  checkFreeShippingAmount(t, e);
                  e.toggle(t);
                });
          } else {
            t.find('tbody.country').filter(function () {
              var e = $(this),
                t = -1 < e.text().toLowerCase().indexOf('rest of world');
              checkFreeShippingAmount(t, e);
              e.toggle(t);
            });
          }
        }),
          t.find('#shipping-search').trigger('keyup'),
          t.find('tbody.country').on('click', function () {
            var e = $(this).find('p');
            e.is('visible'), e.slideToggle('fast').toggleClass('el-content');
          });
      });
    }

    let visitorCountry = sessionStorage.getItem('IPStackVisitorCountry');

    if (visitorCountry) {
      document.getElementById('shipping-search').value = visitorCountry;
      fetchShippingRates();
      $('#shipping-search').trigger('keyup');
      replaceVariables('[COUNTRY]', visitorCountry);
    } else {
      fetchLocationInformation();
      fetchShippingRates();
      $('#shipping-search').trigger('keyup');
    }

    document.querySelectorAll('#shopify-section-announcement-bar .announcement-bar[shipping-modal-enabled]').forEach((el) => {
      el.addEventListener('click', function (event) {
        document.querySelector('.shipping-modal').open();
        return true;
      });
    });
  }
});

class AnnouncementBarWrapper extends HTMLElement {
  constructor() {
    super();
    this.announcementBarMessages = [];
    this.observer = null;
  }

  connectedCallback() {
    this.announcementBarMessages = Array.from(this.querySelectorAll('.announcement-bar__text'));
    if (this.announcementBarMessages.length === 0) return;

    this.equalizeHeights();
    this.observeResize();
  }

  equalizeHeights() {
    let maxHeight = 0;

    // Reset height and measure
    this.announcementBarMessages.forEach(bar => {
      const height = bar.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    this.style.height = `${maxHeight + 8}px`; // Padding
  }

  observeResize() {
    if (typeof ResizeObserver === 'undefined') return;

    this.observer = new ResizeObserver(() => {
      this.equalizeHeights();
    });

    this.announcementBarMessages.forEach(bar => {
      this.observer.observe(bar);
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('announcement-bar-wrapper', AnnouncementBarWrapper);